var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-skeleton-wrapper',[_c('div',{staticClass:"tw-flex tw-flex-col"},[_c('div',[_c('b-skeleton',{attrs:{"width":"100%","height":"32px"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }